import React from "react";

export default function Button({
  children,
  variant = "primary",
  size = "md",
  disabled = false,
  className = "",
  ...props
}) {
  const variants = {
    primary: "bg-[rgb(var(--color-primary))] text-white hover:bg-[rgb(var(--color-primary-hover))]",
    secondary: "bg-[rgb(var(--color-surface-muted))] text-[rgb(var(--color-text))] border border-[rgb(var(--color-border))]",
    danger: "bg-[rgb(var(--color-danger))] text-white",
    ghost: "bg-transparent text-[rgb(var(--color-text))] hover:bg-[rgb(var(--color-surface-muted))]",
  };

  const sizes = {
    sm: "px-2 py-1 text-tok-xs",
    md: "px-4 py-2 text-tok-sm",
    lg: "px-5 py-3 text-tok-base",
  };

  return (
    <button
      disabled={disabled}
      className={`
        inline-flex items-center justify-center rounded-md
        transition-colors font-medium
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}
